export default "__VITE_ASSET__BeINj8kk__"